exports.PAYMENT_METHOD_TC = 'TC';

exports.PAYMENT_METHOD_TD = 'TD';

exports.PAYMENT_METHOD_CBU = 'CBU';

exports.PAYMENT_METHOD_OTHER = 'OTHER';
